import React, { useContext, useEffect, useState } from 'react'
import {DatePicker, Typography, Space, App, Radio, Divider, Descriptions} from 'antd'
import { Helmet } from "react-helmet";
import dayjs, {Dayjs} from 'dayjs'
import { API, Enum, Variable } from "../../../resources/constants";
import language from "../../../resources/languages/en_US"

// Interfaces
import { Bill as ReportBillType } from "../../../interfaces/pages/report"
import { AxiosError } from "../../../interfaces/axios"


// Contexts
import AxiosContext from "../../../contexts/axios";

const { App: { title }, Pages: { Report: { Bill: BillLanguage }  }, Share, Validation, Message: MessageLanguage, Enum: EnumLanguage } = language
const { TENDER_TENDER_BILL } = API
const { Message, Country } = Enum
const { PostedDate } = Variable;

const currency = new Intl.NumberFormat()

const defaultReport = {
    modelNumbers: [],
    partNumbers: [],
    preferredVendors: [],
}

export default function Bill() {

    const [country, setCountry] = useState<string>(Country.USA);
    const [postedDate, setPostedDate] = useState<[Dayjs, Dayjs]>(PostedDate);
    const [report, setReport] = useState<ReportBillType>(defaultReport);

    const { axios } = useContext(AxiosContext)
    const { message } = App.useApp()

    useEffect(() => {
        getReport();
    }, [country, postedDate]);

    const getReport = () => axios.post(TENDER_TENDER_BILL, { from: dayjs(postedDate[0]).format('YYYY-MM-DD'), to: dayjs(postedDate[1]).format('YYYY-MM-DD') }, { params: { source: country } }).then((response: { data: ReportBillType }) => {
        const { data: report } = response;
        setReport(report);
    }, async (error: AxiosError) => {
        const { response: { data } } = error;
        setReport(defaultReport);
        // @ts-ignore
        message.error(MessageLanguage[data.message]||data.message).then(response => response )
    })


    // @ts-ignore
    return (
        <div className={'report-bills'}>
            <Helmet>
                <title>{title} - {BillLanguage.title}</title>
            </Helmet>
            <Space direction={'vertical'} size={30} style={{width:'100%',textAlign:'center'}}>
                <Space size={5}>
                    <Radio.Group value={country} onChange={({target: { value: country }}) => setCountry(country)} buttonStyle={'solid'} className={'radio-group-style-two'}>
                        <Radio.Button value={Country.USA}>
                            <img
                                alt={EnumLanguage.Country[Country.USA]}
                                src={require('../../../resources/media/flag/usa-square.jpg')}
                                width={32}
                                height={32}
                            />
                        </Radio.Button>
                        <Radio.Button value={Country.Canada}>
                            <img
                                alt={EnumLanguage.Country[Country.Canada]}
                                src={require('../../../resources/media/flag/canada-square.jpg')}
                                width={32}
                                height={32}
                            />
                        </Radio.Button>
                        <Radio.Button value={Country.Europe} disabled={true}>
                            <img
                                alt={EnumLanguage.Country[Country.Europe]}
                                src={require('../../../resources/media/flag/europe-square.jpg')}
                                width={32}
                                height={32}
                            />
                        </Radio.Button>
                    </Radio.Group>
                    <Divider type="vertical" style={{height:'2em'}} />
                    <Space size={15}><Typography.Text strong>{BillLanguage.postedDate}</Typography.Text><DatePicker.RangePicker
                        allowClear={false}
                        size={'large'}
                        format="YYYY-MM-DD"
                        // @ts-ignore
                        value={postedDate}
                        // @ts-ignore
                        onChange={(postedDate) => setPostedDate(postedDate)}
                    /></Space>
                </Space>
                <Space direction="vertical" size={30} style={{width:'100%'}}>
                    <Descriptions bordered title={BillLanguage.modelNumbers}>
                        {
                            // @ts-ignore
                            report?.modelNumbers?.filter((item) => item.length > 1).map((item) => <Descriptions.Item key={item[0]} label={item[0]}>{currency.format(item[1])}</Descriptions.Item>)
                        }
                    </Descriptions>
                    <Descriptions bordered title={BillLanguage.partNumbers}>
                        {
                            // @ts-ignore
                            report?.partNumbers?.filter((item) => item.length > 1).map((item) => <Descriptions.Item key={item[0]} label={item[0]}>{currency.format(item[1])}</Descriptions.Item>)
                        }
                    </Descriptions>
                    <Descriptions bordered title={BillLanguage.preferredVendors}>
                        {
                            // @ts-ignore
                            report?.preferredVendors?.filter((item) => item.length > 1).map((item) => <Descriptions.Item key={item[0]} label={item[0]}>{currency.format(item[1])}</Descriptions.Item>)
                        }
                    </Descriptions>
                </Space>
            </Space>
        </div>
    )
}
